import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Sidebar } from './Dashboard';

const API = 'https://tribaltech-backend.onrender.com';

export default function Insights() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const token = localStorage.getItem('tribal_token');
  const headers = { Authorization: 'Bearer ' + token };

  useEffect(() => {
    axios.get(API + '/api/mentions', { headers })
      .then(r => { setData(r.data); setLoading(false); })
      .catch(e => { setError(e.response?.data?.error || 'Failed to load'); setLoading(false); });
  }, []);

  const sentimentColor = (s) => {
    if (s === 'concerning') return '#EF4444';
    return '#8888AA';
  };

  const platformColor = (p) => {
    if (p === 'Reddit') return '#FF4500';
    if (p === 'Twitter') return '#1DA1F2';
    return 'var(--purple-light)';
  };

  return (
    <div className="page">
      <Sidebar />
      <div className="main">
        <div className="page-title">Mentions & Insights</div>

        {loading ? (
          <div className="card" style={{ color:'var(--muted)' }}>Scanning the web for mentions...</div>
        ) : error ? (
          <div className="card" style={{ color:'#FCA5A5' }}>{error}</div>
        ) : (
          <>
            <div className="stat-grid" style={{ marginBottom: 24 }}>
              <div className="stat-card">
                <div className="stat-label">Total mentions</div>
                <div className="stat-value" style={{ color:'var(--purple-light)' }}>{data?.stats?.total || 0}</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Concerning</div>
                <div className="stat-value" style={{ color:'#EF4444' }}>{data?.stats?.concerning || 0}</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Neutral</div>
                <div className="stat-value" style={{ color:'var(--muted)' }}>{data?.stats?.neutral || 0}</div>
              </div>
              {Object.entries(data?.stats?.by_platform || {}).map(([platform, count]) => (
                <div key={platform} className="stat-card">
                  <div className="stat-label">{platform}</div>
                  <div className="stat-value" style={{ color: platformColor(platform), fontSize: 22 }}>{count}</div>
                </div>
              ))}
            </div>

            <div className="card">
              <h3 style={{ fontSize: 15, marginBottom: 16 }}>Recent mentions</h3>
              {(data?.results || []).length === 0 ? (
                <div style={{ color:'var(--muted)', padding:'20px 0', textAlign:'center' }}>
                  No mentions found. Try adding more usernames in Settings.
                </div>
              ) : (
                (data?.results || []).map((item, i) => (
                  <div key={i} style={{
                    padding: '12px 0',
                    borderBottom: '1px solid var(--border)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: 12,
                  }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display:'flex', alignItems:'center', gap: 8, marginBottom: 4 }}>
                        <span style={{ fontSize: 11, color: platformColor(item.platform), fontWeight: 600 }}>
                          {item.platform}
                        </span>
                        <span style={{ fontSize: 11, color: sentimentColor(item.sentiment), fontWeight: 500 }}>
                          {item.sentiment === 'concerning' ? '⚠ Concerning' : '● Neutral'}
                        </span>
                        <span style={{ fontSize: 11, color:'var(--muted)' }}>
                          {item.date ? new Date(item.date).toLocaleDateString() : ''}
                        </span>
                      </div>
                      <a href={item.url} target="_blank" rel="noreferrer"
                        style={{ fontSize: 13, color:'var(--offwhite)', textDecoration:'none' }}>
                        {item.title || item.url?.substring(0, 80)}
                      </a>
                      <div style={{ fontSize: 11, color:'var(--muted)', marginTop: 4 }}>
                        Matched username: {item.username}
                      </div>
                    </div>
                    <a href={item.url} target="_blank" rel="noreferrer"
                      className="btn btn-secondary"
                      style={{ fontSize: 11, padding:'4px 10px', flexShrink: 0 }}>
                      View →
                    </a>
                  </div>
                ))
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
